export default function (context, val) {
    if (val) {
        context.dispatch('agreements/set_comment', context.getters['agreements/agreement'](val));
        context.dispatch('agreements/get_course', context.getters['agreements/agreement'](val));
    }
}